// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading--3Tgyp"};